import React from "react";

// Collapsible section card with cleaner spacing & readable measure
const SectionCard = ({ title, emoji, initiallyOpen = false, children }) => (
  <details
    className="group relative bg-white/95 backdrop-blur border border-sky-100 rounded-2xl shadow-sm overflow-hidden transition hover:shadow-md open:shadow-md"
    open={initiallyOpen}
  >
    <summary
      className="flex items-center gap-3 px-5 py-3 sm:px-6 sm:py-4 cursor-pointer select-none list-none
                 [&::-webkit-details-marker]:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-sky-50"
    >
      {emoji ? (
        <span className="text-xl sm:text-2xl shrink-0" aria-hidden="true">
          {emoji}
        </span>
      ) : null}
      <h3 className="flex-1 text-lg sm:text-xl font-extrabold text-sky-900 tracking-tight">
        {title}
      </h3>
      <span
        className="ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full border border-sky-200 text-sky-700 transition-transform duration-300 group-open:rotate-180"
        aria-hidden="true"
      >
        ▾
      </span>
    </summary>

    <div className="h-px w-full bg-sky-100/80" aria-hidden="true" />

    <div className="px-5 pb-5 sm:px-6 sm:pb-6">
      {/* max-w-prose to keep readable line length; relaxed leading & larger text for mobile */}
      <div className="mx-auto max-w-prose rounded-xl bg-gradient-to-br from-sky-50 to-white p-4 sm:p-5 leading-7 sm:leading-8 text-[15px] sm:text-[16px] text-slate-800">
        {children}
      </div>
    </div>
  </details>
);

const BuildProHomeContent = () => {
  return (
    // Apply Roboto in the container via an arbitrary Tailwind font family
    <div className="bg-gradient-to-b from-sky-50 via-white to-sky-50 font-['Roboto',sans-serif]">
      {/* Load Roboto (400/500/700) for crisp headings & body */}
      <link
        rel="preconnect"
        href="https://fonts.googleapis.com"
      />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
        rel="stylesheet"
      />

      {/* Page container */}
      <div className="mx-auto max-w-6xl px-3 sm:px-6 py-8 sm:py-12 space-y-6 sm:space-y-8">
        {/* Header (centered, balanced, readable) */}
        <div className="text-center mb-2 sm:mb-4">
          <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight">
            <span className="bg-gradient-to-r from-sky-600 via-cyan-500 to-sky-700 bg-clip-text text-transparent drop-shadow-sm">
              BuildPro OGCS
            </span>
            <span className="mx-2 text-slate-300">•</span>
            <span className="text-slate-900">Materials That Build Better</span>
          </h2>
          {/* Optional subhead for context (remove if not needed) */}
          <p className="mt-3 text-slate-600 text-sm sm:text-base">
             • Verified sellers • Pan-India delivery
          </p>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-sky-500 to-cyan-500" />
        </div>

        {/* AAC Blocks */}
        <SectionCard
          title="AAC Blocks — Lightweight, Strong & Eco-Friendly"
          emoji=""
          initiallyOpen={false}
        >
          <p>
            <strong>AAC Blocks - Lightweight, Strong & Eco-Friendly .</strong> Looking for a smarter
            alternative to traditional clay bricks? AAC blocks (Autoclaved Aerated Concrete blocks) are the
            modern choice for energy-efficient,  lightweight, and fast construction. At BuildPro OGCS, we
            offer IS-certified AAC blocks perfect for residential, commercial, and industrial projects. We
            are a trusted AAC block supplier, Delivering across Mumbai, Pune, Thane, Delhi, Bengaluru,
            Hyderabad, Chennai, Ahmedabad, Kolkata, Jaipur, Nashik, Gurugram, Noida, and many more cities
            across India. with quality, consistency, and competitive prices. AAC blocks are 3 times lighter
            than red bricks, reducing structural load. Provide excellent <strong>thermal and sound insulation</strong> .
            Quick to install and reduce construction time by up to 30%.  Resistant to fire, termites, and
            moisture, ensuring long-term performance. Uniform shape, precision, and{" "}
            <strong>eco-friendliness</strong> eco-friendliness make AAC blocks a top choice. Size: 600mm x 200mm x
            (75/100/150/200/250)mm. Weight: Lightweight – ~8–15 kg/block. Compressive Strength: 4–5 N/mm².
            Thermal Conductivity: <strong>Thermal Conductivity:</strong> ~0.16 W/mK. Application:
            <strong>External & internal walls</strong> , partition walls, high-rise construction. As a leading
            construction material supplier, we ensure each AAC block meets Indian standards for strength,
            density, and performance. Choose BuildPro OGCS for all your construction materials online and enjoy:
            Bulk pricing for builders and contractors. Quick delivery & site unloading. Expert advice for block
            usage and quantity estimation. <strong>Hassle-free returns and replacements</strong>.  We are more than just an
            AAC block supplier – we are your full-service construction material company. Build Green. Build
            Smart. Built with AAC Blocks. Join satisfied builders who trust BuildPro OGCS for their AAC block
            needs. Save time, reduce costs, and increase thermal efficiency with the best alternative to
            traditional bricks. Buy AAC blocks online now — fast delivery, fair pricing, and expert service{" "}
            <a
              href="https://buildpro.ogcs.co.in/product/details/688071678af146a74b102a72"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* TMT Steel Bars */}
        <SectionCard title="TMT Steel Bars — Strong Foundation for Every Structure" emoji="">
          <p>
            <strong>TMT Steel Bars – Strong Foundation for Every Structure .</strong> When it comes to
            building strength and safety into your structure, TMT steel bars are the most trusted
            reinforcement solution. At BuildPro OGCS, we supply top-quality TMT steel bars sourced from
            India’s leading manufacturers. As a reliable TMT bar supplier, we offer a wide range of sizes
            and grades for residential, commercial, and  <strong>infrastructure projects</strong>. TMT steel bars
            offer excellent tensile strength, bendability, and  <strong>earthquake resistance</strong> . The ribbed
            surface ensures better bonding with concrete for RCC structures. Our TMT steel bars are{" "}
            <strong>corrosion-resistant and tested</strong> for superior load capacity. Available in Fe 500,
            Fe 500D, and Fe 550 grades with full-length customisation. Ideal for beams, columns, slabs, and
            foundation work. Sizes Available: 8mm, 10mm, 12mm, 16mm, 20mm, 25mm, 32mm. Grade Options: Fe 500,
            Fe 550, Fe 500D. Length: Standard 12-meter or customised. Application: Residential homes,
            high-rise buildings, bridges, and industrial structures. As a{" "}
            <strong>trusted construction material supplier</strong>, BuildPro OGCS ensures on-time delivery and top-quality
            assurance for every TMT steel bar you order. Guaranteed quality from top Indian brands. Instant
            quotation & bulk pricing. Quick delivery across Mumbai, Pune, Thane & more.{" "}
            <strong>Technical support by civil engineers</strong>. Whether you're a contractor or individual home builder,
            BuildPro OGCS is your trusted partner for TMT steel bar supply and other construction materials
            online. Build Strong, Build Smart  <strong>Build Strong, Build Smart</strong>  – With TMT Steel Bars from
            BuildPro OGCS. Experience the ease of ordering all your construction materials from India’s
            top-rated construction material company. From TMT steel bars to GFRP bars, we deliver strength,
            quality, and peace of mind{" "}
            <a
              href="https://buildpro.ogcs.co.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* GFRP Bars */}
        <SectionCard title="GFRP Bars — Smart, Non-Corrosive Replacement for Steel" emoji="">
          <p>
            <strong>GFRP Bars – The Smart Replacement for TMT Steel.</strong> Looking for a
            corrosion-resistant, lightweight, and high-strength alternative to steel? GFRP bars (Glass Fibre
            Reinforced Polymer) are the future of construction. At BuildPro OGCS, we bring you top-grade GFRP
            bars that outperform traditional <strong> TMT steel in strength, durability, and longevity</strong>. As a
            leading GFRP bar supplier, we provide a wide range of options suitable for residential, commercial,
            industrial, and infrastructure projects.   GFRP bars are non-corrosive, making them ideal for
            coastal, marine, or  <strong>chemical environments</strong>. Being 1/4th the weight of steel, they are easier
            to transport and install.  <strong>  Zero maintenance cost and longer lifespan</strong> make GFRP bars the best
            choice for long-term projects. High tensile strength and thermal stability ensure superior
            performance in high-stress applications. 100% rust-proof <strong>  100% rust-proof</strong>, moisture-resistant,
            and chemically inert — the GFRP bar advantage is unmatched. That’s why more builders and civil
            engineers are switching to GFRP bars every day. Diameter: 8mm, 10mm, 12mm, 16mm, 20mm+. Length:
            Standard 3, 6, 9, and 12 meter bars. Coating: Resin bonded,  <strong> UV protected</strong>. Material:
            High-grade Glass Fibre + Polymer resin. Application: Bridges, roads, coastal buildings, high-rise
            structures. At BuildPro OGCS, every GFRP bar is tested for quality, durability, and{" "}
            <strong> compliance with national standards</strong>. We ensure only the best materials reach your project site.
            Get GFRP Bars Delivered to Your Site – Fast & Affordable{" "}
            <a
              href="https://buildpro.ogcs.co.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Cement */}
        <SectionCard title="Cement — Buy Online at the Best Price" emoji="">
          <p>
            <strong> Buy Cement Online at the Best Price –.   </strong>
            Looking to buy cement online for your construction project? BuildPro OGCS is India’s trusted
            construction material supplier, offering a wide selection of <strong>premium-quality cement</strong>  from top
            brands like UltraTech Cement, ACC Cement, Ambuja Cement, JK Cement, and many more. Whether you're
            constructing a residential home, developing a commercial building, or executing RCC work, we
            provide the best cement for construction to meet your specific project needs. Choose from a full
            range of cement grades to suit various applications:{" "}
            <strong>OPC Cement (Ordinary Portland Cement)</strong> – Ideal for RCC structures, columns, and slabs. PPC
            Cement (Portland Pozzolana Cement) – Excellent for general construction and improved workability.{" "}
            <strong>PSC Cement (Portland Slag Cement)</strong> – High resistance to sulfate and water exposure, ideal for
            coastal areas. All our construction cement options are tested for quality, durability, and weather
            resistance. We supply only  <strong>ISI-certified and industry-standard</strong> materials.  Wide selection of
            construction materials online under one roof.  Doorstep delivery across Mumbai, Pune, Thane, and
            major Indian cities.  Live cement prices and transparent cost estimation.  Expert support from civil
            engineers and material advisors.  Bulk cement orders for{" "}
            <strong>contractors and builders</strong>. We serve individual homeowners, civil contractors, builders, and
            architects, providing access to all major construction materials online, including:  Bricks and AAC
            Blocks,  M Sand and River Sand,  Aggregates / Jelly stones,  TMT Steel Bars,  Waterproofing
            Chemicals,  Wall Putty and Paints,  Plywood and Laminates,  Electrical materials,  Plumbing & 
            Sanitary products,{" "}
            <strong>Construction Tools and Machinery</strong>. With BuildPro OGCS, you're not just buying materials – 
            you're building smart with India’s leading construction material platform. We are India’s
            fastest-growing construction material company, committed to making construction easier, faster, and
            more affordable. Whether you are a contractor, civil engineer, or homeowner, we help you buy
            building materials online – from cement and TMT bars to sand, bricks, and{" "}
            <strong>waterproofing chemicals</strong> – all at the best rates. Our logistics ensure the on-time and safe
            delivery of cement and other construction materials, helping you avoid project delays and cost
            overruns.  Order Cement Online – Fast Delivery &{" "}
            <strong>Bulk Deals Available</strong>. Join over  satisfied contractors and engineers who trust BuildPro OGCS as
            their go-to online cement supplier. Experience the convenience of shopping for all your construction
            materials from one trusted online store.  Start building smarter. Order cement online and Offline
            today from BuildPro OGCS!
            <a
              href="https://buildpro.ogcs.co.in/product/details/67f8c8a46b4d2bcb48fc2649"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
          </p>
        </SectionCard>

        {/* Wall Putty */}
        <SectionCard title="Wall Putty — Smooth Finish, Crack-Free Walls" emoji="">
          <p>
            <strong>Wall Putty – Smooth Finish for Strong, Crack-Free Walls .</strong>
            Looking for the perfect wall surface before painting? Wall putty is essential for achieving a
            smooth, uniform, and durable finish on interior and exterior walls. At BuildPro OGCS, we supply
            high-performance wall putty from leading brands like Birla White, JK Wall Putty, and Asian Paints.
            We are a trusted wall putty supplier,{" "}
            <strong>delivering high-quality</strong> materials to builders, contractors, and homeowners across   Mumbai,
            Pune, Thane, Delhi, Bengaluru, Hyderabad, Chennai, Ahmedabad, Kolkata,  Jaipur, Nashik, Gurugram,
            Noida, and many more cities across India.. Wall putty provides a white, smooth base that enhances
            paint <strong>adhesion and coverage</strong>. Increases paint life and prevents flaking, dampness, and wall
            cracks. Suitable for new walls as well as old, damaged surfaces.{" "}
            <strong>Resists moisture and UV damage</strong> , ensuring wall longevity. Easy to apply, sand, and repaint – 
            ideal for interior and exterior walls. With the right wall putty, you ensure a premium finish and
            long-term paint performance. Type: <strong>White Cement-Based Putty & Acrylic Putty</strong>. Packaging: 20
            kg, 30 kg bags. Drying Time: 4–6 hours. Finish: Smooth, matte base. Application: Walls, ceilings,
            concrete, and plaster surfaces. As your reliable construction material supplier, BuildPro OGCS{" "}
            <strong>guarantees</strong> the best quality wall putty with verified shelf life, consistency, and{" "}
            <strong>application support</strong>. Looking to source wall putty online for your construction or painting
            project? We make it easy to: Access bulk discounts and real-time pricing. Choose between{" "}
            <strong>top brands and grades</strong>. Get fast delivery and safe packaging. Receive expert help in surface
            preparation. We’re more than just a wall putty supplier — we’re your all-in-one construction
            material company serving all types of building needs.  Build <strong>Beautiful Interiors</strong> with Wall
            Putty from BuildPro OGCS. Trust India's most efficient construction materials online platform for
            your next <strong>painting or renovation project</strong>. With the right wall putty, you lay the foundation
            for perfect walls and perfect paint.  Buy wall putty online today and get the best deals only at
            BuildPro OGCS{" "}
            <a
              href="https://buildpro.ogcs.co.in/product/details/67fcec2a4c7bfe2bd4d79aab"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
             Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Construction Tools */}
        <SectionCard title="Construction Tools — Durable, Ergonomic, Job-Ready" emoji="">
          <p>
            <strong>
              Construction Tools – High-Quality Tools for Precision & Performance .
            </strong>
            Every construction project demands the right tools. At <strong>BuildPro OGCS</strong>, we supply a
            wide variety of construction tools to meet the requirements of <strong> contractors</strong> , masons,
            plumbers, electricians, and civil engineers. From hand tools to power tools, we offer everything to
            simplify on-site work and improve <strong>efficiency</strong>. We are a dependable construction tools supplier
            with fast delivery across Mumbai, Pune, Thane, and other cities across India. Construction tools
            ensure <strong>faster, safer, and more accurate work</strong> on-site. Our tools are made from high-grade
            materials for durability and reliability. Available for all construction trades — masonry,
            carpentry, electrical, plumbing, and finishing. Ergonomic, easy to handle, and designed to
            withstand heavy-duty usage. Each tool comes with a warranty and quality <strong>certification</strong>. Whether
            you’re doing brickwork, steel cutting, tile laying, or drilling, our{" "}
            <strong>construction tools</strong> are built to perform. Hand Tools: Hammers, pliers, measuring tapes,
            trowels. Power Tools: Angle grinders, drill machines, concrete mixers. Finishing Tools: Plastering
            floats, scrapers, cutters. Plumbing Tools: Pipe cutters, wrenches, threaders. Masonry Tools:
            Chisels, levels, mason lines. Every product is sourced from leading brands and tested for quality.
            As your <strong>reliable construction material supplier</strong>, we offer the right tool for every task. Need
            tools delivered to your site quickly? Buy construction tools online and enjoy: Access to 100+ tool
            types at <strong>competitive prices</strong>. Bulk availability for projects and contractor needs. Timely
            doorstep delivery across job sites. Expert recommendations for tool selection and safety. We’re more
            than just a construction tools supplier — BuildPro OGCS is your complete construction material
            company.  Build <strong>Efficiently</strong> with Construction Tools from BuildPro OGCS. Find the
            best-in-class construction materials online, including <strong>essential tools</strong> for every stage of
            your project. From digging to finishing, our construction tools are trusted by pros across India.
            Buy construction tools online today and equip your site for success{" "}
            <a
              href="https://buildpro.ogcs.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Plumbing & Electrical (Part 1) */}
        <SectionCard
          title="Plumbing & Electrical Materials — Safe & Seamless Installations"
          emoji=""
        >
          <p>
            <strong>
              Plumbing & Electrical Materials – Complete Range for Safe & Seamless Installations .
            </strong>{" "}
            Planning your construction or renovation project? You can’t compromise on quality when it comes to{" "}
            <strong>plumbing and electrical materials</strong> . At BuildPro OGCS, we offer a complete range of plumbing
            and electrical materials from leading Indian brands, ensuring safety, durability, and performance
            in every project. As a <strong>trusted plumbing</strong> and electrical material supplier, we deliver to
            residential buildings, commercial projects, and <strong>industrial setups</strong> across Mumbai, Pune, Thane,
            Delhi, Bengaluru, Hyderabad, Chennai, Ahmedabad, Kolkata, Surat, Jaipur, Nashik, Gurugram, Noida,
            and many more cities across India.. Plumbing and electrical materials ensure seamless installation
            and <strong>long-term</strong> reliability. Prevents short circuits, water leakage, and system failures.
            Available in various grades, gauges, and <strong>finishes</strong> to match project specifications. All
            products are <strong>ISI certified</strong> and compliant with <strong>BIS standards</strong>. Ready-to-install kits and
            bulk project support are available. With BuildPro OGCS, get your entire supply of plumbing and
            electrical materials in one place. Plumbing Materials: CPVC, UPVC, SWR, GI, and PPR Pipes.{" "}
            <strong>Fittings</strong> (tees, elbows, unions, reducers). Faucets, taps, valves, clamps, tanks{" "}
            <a
              href="https://buildpro.ogcs.co.in/product"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Electrical (Part 2) */}
        <SectionCard title="Electrical Materials — Genuine, Tested & Warranty-Backed" emoji="">
          <p>
            <strong>Electrical Materials:</strong>{" "}
            Wires (single-core, multi-core), cables. <strong>Switches</strong>, sockets, MCBs, DB boxes.
            Conduits, junction boxes, panels. All materials are <strong>quality-verified</strong>and backed by warranty. As
            a reliable construction material supplier, we help you avoid cheap imitations and deliver{" "}
            <strong>genuine products</strong>. Looking for fast procurement? Buy plumbing and electrical materials online
            and enjoy: Bulk rates for <strong>contractors and builders</strong>. Brand options like Finolex, Polycab,
            Astral, and Supreme. Site delivery across cities with tracking. Expert guidance for choosing the
            right specifications. Whether it's a small project or a large-scale development, trust the leading
            plumbing and electrical material supplier for consistent{" "}
            <strong>quality and timely delivery</strong>.  Build Safe, Build Smart – With Plumbing & Electrical Materials
            from BuildPro OGCS. From wiring a home to plumbing a high-rise, get all your construction materials
            online — only at BuildPro OGCS. We are India’s one-stop construction material company{" "}
            <strong>trusted by  professionals</strong>. 🔗 Buy plumbing and electrical materials online today and power your
            project with confidence{" "}
            <a
              href="https://buildpro.ogcs.co.in/products/67fe2a9d6129d8739a1d39f3"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Hand Tools */}
        <SectionCard title="Hand Tools — Durable, Ergonomic & Site-Ready" emoji="">
          <p>
            <strong>
              Hand Tools – Durable, Ergonomic & Ready for Every Site Task .
            </strong>{" "}
            When it comes to everyday construction tasks, nothing beats the reliability of good hand tools. At
            BuildPro OGCS, we offer a full range of <strong>high-performance hand tools</strong> designed for masonry,
            carpentry, electrical work, plumbing, and general site use. As a dependable hand tools supplier, we
            deliver precision tools to contractors, engineers, and technicians Delivering across Mumbai, Pune,
            Thane, Delhi, Bengaluru, Hyderabad, Chennai, Ahmedabad, Kolkata, Surat, Jaipur, Nashik, Gurugram,
            Noida, and many more cities across India.. Hand tools are essential for quick, precise, and
            flexible jobsite tasks. Designed with ergonomic grips and <strong>industrial-grade materials</strong> for long
            life. Suitable for cutting, fixing, measuring, bending, tightening, and shaping tasks. Ideal for
            on-site as well as workshop use — both <strong>light and heavy-duty</strong> applications. All tools are tested
            for safety, durability, and usability in tough conditions. When you're equipped with the right hand
            tools, your job gets easier, faster, and more accurate. <strong>Cutting Tools</strong>: Hacksaws, knives,
            cutters. Measuring Tools: Measuring tapes, spirit levels, rulers. Striking Tools: Hammers, mallets,
            chisels. Fastening Tools: Spanners, wrenches, screwdrivers, pliers. Masonry Tools: Trowels, floats,
            brick jointers. BuildPro OGCS ensures every product we supply meets quality and performance
            benchmarks. As your trusted construction material supplier, we deliver tools that professionals
            rely on. Looking for the right tools without hunting through <strong>hardware shops</strong>? Buy hand tools
            online from BuildPro OGCS and get: Brand-certified tools at competitive rates. Bulk order facility
            for project teams. <strong>Quick dispatch & tracked site delivery</strong>. Expert suggestions for toolkits and
            job-specific requirements. As a leading hand tools supplier, we are also your complete construction
            material company, offering everything from cement and TMT bars to finishing supplies.  Build
            Smarter, Work Faster – With Hand Tools from BuildPro OGCS. Equip your team with{" "}
            <strong>premium-quality</strong> construction materials online, including durable and dependable hand tools.
            Choose <strong>BuildPro OGCS</strong> – trusted by  professionals across India.  Buy hand tools online now and
            power your next project with precision{" "}
            <a
              href="https://buildpro.ogcs.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Paint */}
        <SectionCard title="Paint — Vibrant, Long-Lasting Wall Finishes" emoji="">
          <p>
            <strong>Paint – Vibrant, Long-Lasting Wall Finishes .</strong>{" "}
            A fresh coat of paint doesn’t just beautify your space — it protects, enhances, and reflects your
            style. At BuildPro OGCS, we supply <strong>premium-quality</strong> paint products from top brands like Asian
            Paints, Nerolac, Berger, Indigo, and Dulux. We are a <strong>trusted paint</strong> supplier offering
            decorative, waterproof, heat-reflective, and <strong>industrial paints</strong>— delivered quickly Delivering
            across Mumbai, Pune, Thane, Delhi, Bengaluru, Hyderabad, Chennai, Ahmedabad, Kolkata,  Jaipur,
            Nashik, Gurugram, Noida, and many more cities across India.. Our paint range includes emulsions,
            primers, distempers, textures, and exterior coatings. Excellent coverage, colour retention, and{" "}
            <strong>weather resistance. Anti-fungal</strong>, low-VOC, and quick-drying options are available. Paints for
            walls, ceilings, wood, metal, flooring, and rooftops. Easy application with brush, roller, or
            spray — beginner to pro use. Make your walls speak with rich colours,{" "}
            <strong>smooth textures</strong>, and durable finishes using high-grade paint products{" "}
            <a
              href="https://buildpro.ogcs.co.in/product/details/67f8c8a46b4d2bcb48fc2649"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Interior/Exterior Paint Types */}
        <SectionCard title="Interior & Exterior Paint Types" emoji="">
          <p>
            <strong>Interior Paints:</strong>{" "}
            Acrylic Emulsions, Royal Luxury, Plastic Paints. Exterior Paints: Weatherproof Emulsions,{" "}
            <strong>Textured Finishes</strong>. Primers & Undercoats: Cement Primer, Metal Primer,{" "}
            <strong>Wall Putty Combo</strong>. Speciality Paints: <strong>Heat reflective</strong>, waterproofing paint, wood
            coatings{" "}
            <a
              href="https://buildpro.ogcs.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Paint Pack Sizes */}
        <SectionCard title="Paint Packs & Buying Support" emoji="">
          <p>
            <strong>Pack Sizes:</strong>{" "}
            1L, 4L, 10L, 20L. All paint products from BuildPro OGCS are sourced directly from{" "}
            <strong>certified manufacturers</strong>. As your reliable construction material supplier, we offer technical
            assistance in shade selection, area coverage, and <strong>product compatibility</strong>. Looking to buy paint
            online for your next project? Choose BuildPro OGCS for: Real-time price & shade card availability.
            Bulk quantity support for homes & <strong>commercial projects</strong>. Site delivery and proper packaging.
            Expert advice on product selection and the painting process. We are not just a paint supplier, but a
            complete construction material company for <strong>professionals and homeowners</strong> alike.  Paint Smart.
            Paint Beautiful - With Quality Paint from BuildPro OGCS. Explore a world of finishes, textures, and
            rich colours. At BuildPro OGCS, get all your construction materials online, including top-grade
            paint that lasts for years.  Buy paint online today and transform your space with every brushstroke{" "}
            <a
              href="https://buildpro.ogcs.co.in/product/details/67f8c8a46b4d2bcb48fc2649"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block ml-1 text-sky-700 underline underline-offset-4 decoration-sky-300 hover:text-sky-900 hover:decoration-sky-500"
            >
              Read More
            </a>
            .
          </p>
        </SectionCard>

        {/* Small helper style */}
        <style>{`
          summary::-webkit-details-marker { display: none; }
        `}</style>
      </div>
    </div>
  );
};

export default BuildProHomeContent;
